export default "__VITE_ASSET__1FxpYAZm__"